import type { Patient } from "@louise/medical-history/basic-info/calculateBasicInfoCompletion";

export function calculateMedicationsVaccinesCompletion(
  patient: Patient | null | undefined,
) {
  const currentlyTakingMedications =
    patient?.medicalHistory?.currentlyTakingMedications;
  const meds = patient?.medicalHistory?.medications;

  // Check if user has answered the "are you taking medications?" question
  const answeredFlag =
    currentlyTakingMedications !== undefined &&
    currentlyTakingMedications !== null;
  const hasAny = Array.isArray(meds) && meds.length > 0;

  // If they answered "No" (currentlyTakingMedications === false), count as complete
  // If they answered "Yes", they need at least one medication for full completion
  const completed = answeredFlag
    ? 1 + (currentlyTakingMedications ? (hasAny ? 1 : 0) : 1)
    : 0;
  const percent = completed / 2;
  const label = answeredFlag
    ? currentlyTakingMedications
      ? hasAny
        ? "2/2 answered"
        : "1/2 answered"
      : "2/2 answered"
    : "0/2 answered";

  return { percent, label, completed, total: 2 };
}
